/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NeighborPickupsRow,
    NeighborPickupsRowFromJSON,
    NeighborPickupsRowFromJSONTyped,
    NeighborPickupsRowToJSON,
} from './';

/**
 * 他社乗車のリポート
 * @export
 * @interface NeighborPickupsList
 */
export interface NeighborPickupsList {
    /**
     * 
     * @type {Array<NeighborPickupsRow>}
     * @memberof NeighborPickupsList
     */
    neighborReports?: Array<NeighborPickupsRow>;
}

export function NeighborPickupsListFromJSON(json: any): NeighborPickupsList {
    return NeighborPickupsListFromJSONTyped(json, false);
}

export function NeighborPickupsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): NeighborPickupsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'neighborReports': !exists(json, 'neighbor_reports') ? undefined : ((json['neighbor_reports'] as Array<any>).map(NeighborPickupsRowFromJSON)),
    };
}

export function NeighborPickupsListToJSON(value?: NeighborPickupsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'neighbor_reports': value.neighborReports === undefined ? undefined : ((value.neighborReports as Array<any>).map(NeighborPickupsRowToJSON)),
    };
}


